import { Injectable } from '@angular/core';
import { ScriptLoaderService, StylesheetLoaderService } from 'ras-util';
import { forkJoin, take } from 'rxjs';
import { DeferredConfigModel } from '../../models/start-up-config/deferred-config';
import { UrlConfigModel } from '../../models/start-up-config/initial-config.model';
import { StartUpConfigUiService } from './start-up-config-ui.service';
import { SessionTrackerService } from '../data/session-tracker.service';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private persistantStorage: Storage = sessionStorage;

  constructor(
    private startUpConfigUiService: StartUpConfigUiService,
    private scriptLoaderService: ScriptLoaderService,
    private styleLoaderService: StylesheetLoaderService,
    private sessionTrackerService: SessionTrackerService
  ) {}

  public initSessionTracker(): void {
    this.startUpConfigUiService.sessionInfo$.pipe(take(1)).subscribe({
      next: (sessionInfo) => {
        if (sessionInfo?.isNewRastreatorSession) {
          this.sessionTrackerService.initSessionTracker().pipe(take(1)).subscribe();
        }
      }
    });
    this.addMobileTracking();
  }

  public loadDeferredFile(): void {
    forkJoin([
      this.startUpConfigUiService.initialConfig$.pipe(take(1)),
      this.startUpConfigUiService.deferredConfig$.pipe(take(1))
    ]).subscribe(([initialConfig, deferredConfig]) => {
      // for performance purpose, loading additional scripts is delayed.
      setTimeout(() => {
        this.loadScripts(initialConfig, deferredConfig);
        this.loadStyles(initialConfig);
      }, 0);
    });
  }

  private addMobileTracking() {
    if (!this.persistantStorage.getItem('MobileTracking')) {
      if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.maxTouchPoints > 1) {
        this.persistantStorage.setItem('MobileTracking', 'MobileTrackingDevice');
        this.sessionTrackerService.initMobileUserTracker('MobileTrackingDevice').pipe(take(1)).subscribe();
      }
    }
  }

  // Load 3rd party scripts
  private loadScripts(urlConfig: UrlConfigModel, defferedConfig: DeferredConfigModel): void {
    this.scriptLoaderService
      .load({
        name: 'snap-engage',
        src: urlConfig?.snapEngageScriptUrl,
        deferred: true,
        asynchronous: true
      })
      .pipe(take(1))
      .subscribe();
    const isCookieBarVisible = (location.hostname.includes('seguros.es') || location.hostname.includes('segurostest.es')) ? true : (defferedConfig.isCookieBarVisible);
    if (isCookieBarVisible) {
      this.scriptLoaderService
        .load({
          name: 'cookie-consent',
          src: urlConfig?.cookieConsentScriptUrl,
          deferred: true,
          asynchronous: true
        })
        .pipe(take(1))
        .subscribe(() => {
          this.startUpConfigUiService.loadConsentScript$.next(true);
        });
    }
  }

  private loadStyles(urlConfig: UrlConfigModel): void {
    this.styleLoaderService
      .load({
        name: 'cookie-consent',
        href: urlConfig?.cookieConsentStyleUrl
      })
      .pipe(take(1))
      .subscribe();
  }
}
